<template lang="pug">
  #EditStock
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 庫存管理_{{ eventName }}
    .container-width
      .stock-info
        .stock-card(
          v-for="(item, index) in products",
          :key="item.id"
        )
          .el-image.inline-block.hidden
            img.h-100.w-100.align-top(
              v-lazy="item.pic",
            )
          .info.d-flex.align-items-center.p-1
            span.pr-1 庫存
            b-form-input(
              type="number"
              style="border-radius: 5px;",
              @change="changeAmount(item.id)()"
              v-model="products[index].quantity"
            )
            span.pl-1 個
      .row.no-gutters.justify-content-center.pb-7
          .col-5
            b-button.font-weight-bold.btn-custom(
              v-show="isLoading"
              variant="primary",
              block,
              @click="submit()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 送出
</template>

<script>
import { mapState } from 'vuex';
const _ = require('lodash');

export default {
  name: 'EditStock',
  props: {
    storeId: {
      type: [String, Number],
    },
    eventId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isLoading: 0,
      stock:[],
    };
  },
  mounted() {
    const vm = this;
    !vm.storeId || !vm.eventId ? vm.$router.back() :vm.initHandler();
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_order_online/getProductHandler', {storeId: this.storeId, eventId: this.eventId})
        .then(() => {
          vm.isLoading = 1;
          vm.$swal.close();
        });
    },
    changeAmount(id) {
      return _.throttle(()=> {
        let newAmount = this.products.find(i => i.id === id);
        let isUpdated=false;
        this.stock.forEach((item, i) => {
          if(item.id === newAmount.id){
            isUpdated= true;
            this.stock[i].quantity = newAmount.quantity;
          }
        })
        if(!isUpdated) {
          this.stock.push({id: newAmount.id, quantity: newAmount.quantity})
        }
      }, 1000)
    },
    submit() {
      const vm = this;
      if(vm.stock.length === 0) {
        vm.$swal.fire({
          icon: 'error',
          title: '尚未編修庫存'
        });
        return
      }
      vm.$swal.fire({
            title: '您確定要送出嗎？',
            icon: 'info',
            confirmButtonText: '確定',
            showCancelButton: true,
            cancelButtonText: '取消',
            reverseButtons: true,
        }).then(res => {
          if(res.isConfirmed) {
            vm.$swal.fire({
            title: '庫存送出中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              this.$swal.showLoading();
            }
          });
          vm.$store.dispatch('sa_order_online/updateProductHandler', {
            storeId: vm.storeId,
            eventId: vm.eventId,
            products: vm.stock
          })
          .then(() => {
            vm.$swal.close();
            vm.stock = [];
            vm.$swal.fire({
              icon: 'success',
              title: '修改成功',
              showConfirmButton: false,
              timer: 1500
            })
          });
          }
        });
    }
  },
  computed: {
    ...mapState({ 
      eventName: (state) => state.sa_order_online.product.eventName,
      products: (state) => _.cloneDeep(state.sa_order_online.product.products),
    })
  }
};
</script>

<style lang="scss" scoped>
.amount-input {
  flex: 1;
  text-align: center;
  padding: 0.375rem 0.2rem;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control {
  flex: 1;
  text-align: center;
  padding: 0.375rem 0.2rem;
}
  .stock-info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 20px 16px 16px 16px;
      .stock-card {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 31%;
        flex: 0 0 31%;
        border: 1px solid #aaa;
        padding-bottom: 0.5rem;
        margin-bottom: 0.8rem;
        span {
          font-size: 14px
        }
      }
  }
</style>
